












































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

export interface RelationItem {
    code: string;
    variant: string | null;
    variant_name: string | null;
    gu: string;
    gu_type: 'gu' | 'gkkp';
    year: number | null;
    number: string | null;
    link: string;
    region_code?: string | null;
}

export interface RelationResult {
    source: 'bp' | 'be' | 'bip';
    action: 'block' | 'allow';
    data: RelationItem[];
    abp: number;
    prg: number;
    ppr: number | null;
}

@Component
export default class TransferRelationsModal extends Vue {
    @Prop({ default: () => [] }) results!: RelationResult[];
    @Prop({ default: null }) title!: string | null;

    get resolvedTitle(): string {
        return this.title ?? this.$t('modules.transfert.toasts.project_cannot_be_deleted_related') as string;
    }

    private expandedKeys: Set<string> = new Set();

    get blockedResults(): RelationResult[] {
        return (this.results || []).filter(r => r.action === 'block');
    }

    get groupedBySource(): Record<string, RelationResult[]> {
        const map: Record<string, RelationResult[]> = {};
        for (const r of this.blockedResults) {
            if (!map[r.source]) map[r.source] = [];
            map[r.source].push(r);
        }
        return map;
    }

    resetExpanded() {
        this.expandedKeys = new Set();
        this.$forceUpdate();
    }

    toggle(...parts: Array<string | number>) {
        const key = parts.join('|');
        if (this.expandedKeys.has(key)) {
            this.expandedKeys.delete(key);
        } else {
            this.expandedKeys.add(key);
        }
        this.$forceUpdate();
    }

    isOpen(...parts: Array<string | number>): boolean {
        return this.expandedKeys.has(parts.join('|'));
    }

    sourceLabel(source: string): string {
        if (source === 'bp') return this.$t('modules.transfert.relation_sources.bp') as string;
        if (source === 'bip') return this.$t('modules.transfert.relation_sources.bip') as string;
        return this.$t('modules.transfert.relation_sources.be') as string;
    }

    collectBipItems(results: RelationResult[]): RelationItem[] {
        const seen = new Set<string>();
        const items: RelationItem[] = [];
        for (const r of results) {
            for (const item of r.data) {
                const key = `${item.code}|${item.variant}|${item.gu}|${item.year}`;
                if (!seen.has(key)) {
                    seen.add(key);
                    items.push(item);
                }
            }
        }
        return items;
    }

    codeLabel(code: string): string {
        const labels: Record<string, string> = {
            form331: this.$t('modules.transfert.relation_codes.form331') as string,
            form339: this.$t('modules.transfert.relation_codes.form339') as string,
            form359: this.$t('modules.transfert.relation_codes.form359') as string,
            ipf: this.$t('modules.transfert.relation_codes.ipf') as string,
            spr: this.$t('modules.transfert.relation_codes.spr') as string,
        };
        return labels[code] ?? code;
    }

    guLabel(item: RelationItem): string {
        return item.gu_type === 'gkkp' ? this.$t('modules.transfert.gu_type_gkkp') as string : this.$t('modules.transfert.gu_type_gu') as string;
    }

    formatKbk(abp: number, prg: number, ppr: number | null): string {
        const pad = (n: number) => String(n).padStart(3, '0');
        return `${pad(abp)}.${pad(prg)}.${pad(ppr ?? 0)}`;
    }

    groupByCode(items: RelationItem[]): Record<string, RelationItem[]> {
        const map: Record<string, RelationItem[]> = {};
        for (const item of items) {
            if (!map[item.code]) map[item.code] = [];
            map[item.code].push(item);
        }
        return map;
    }

    groupByGu(items: RelationItem[]): Record<string, RelationItem[]> {
        const map: Record<string, RelationItem[]> = {};
        for (const item of items) {
            const key = item.gu || '—';
            if (!map[key]) map[key] = [];
            map[key].push(item);
        }
        return map;
    }
}
